<template>
  <div class="accomodations-values">
    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Valores por acomodações
      </PmwHeading>

      <PmwParagraph class="form--subtitle" size="paragraph-40">
        Configure por tipo de acomodação se desejar um valor diferente do padrão
        apenas para esta tarifa.
      </PmwParagraph>
    </div>

    <!-- BOTÃO DE MOSTRAS INPUTS -->
    <div v-if="!showInputs" class="form--row">
      <PmwButton
        :hasIcon="true"
        layout="outline"
        variation="blue-100"
        class="form--button"
        @click="showInputs = true"
      >
        Adicionar valores por acomodações
      </PmwButton>
    </div>

    <!-- INPUTS DOS CAMPOS DE NOITE GRATIS -->
    <div v-if="showInputs" class="form--row">
      <AccomodationsValuesInputs
        :boardData="fluctuationData.diferenciaisQuartos"
        @closeInputs="removeAccomodationsHandler"
      />
    </div>
  </div>
</template>

<script>
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import AccomodationsValuesInputs from './AccomodationsValuesInputs'

export default {
  name: 'AccomodationsValues',
  components: {
    PmwHeading,
    PmwButton,
    AccomodationsValuesInputs,
    PmwParagraph
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    },

    isOpen: {
      type: Boolean,
      default: false
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showInputs: false
    }
  },

  watch: {
    showInputs(newVal) {
      if (newVal) {
        if (!this.hotelRoomsData?.length) {
          this.$emit('load-hotel-rooms-data')
        }

        this.createObjects()
      }
    },

    'fluctuationData.quartos'(newVal) {
      this.addNewRoom(newVal)
    },

    isOpen: {
      handler(newVal) {
        if (
          newVal &&
          this.fluctuationData.diferenciaisQuartos &&
          this.fluctuationData.diferenciaisQuartos?.length
        ) {
          this.showInputs = true
        }
      },
      immediate: true
    }
  },

  created() {
    if (
      !this.fluctuationData.diferenciaisQuartos &&
      this.fluctuationData.diferenciaisQuartos?.length
    ) {
      this.showInputs = true
    }
  },

  methods: {
    addNewRoom(rooms) {
      const { diferenciaisQuartos } = this.fluctuationData

      if (diferenciaisQuartos && diferenciaisQuartos?.length) {
        const roomsRemoved = diferenciaisQuartos.filter(
          (roomDifferential) => !rooms.includes(roomDifferential.codigoQuarto)
        )

        roomsRemoved.forEach((roomToRemove) => {
          const indexToRemove = diferenciaisQuartos.findIndex(
            (roomDifferential) =>
              roomDifferential.codigoQuarto === roomToRemove.codigoQuarto
          )
          if (indexToRemove !== -1) {
            diferenciaisQuartos.splice(indexToRemove, 1)
          }
        })

        const roomsNotInDifferential = rooms.filter(
          (room) =>
            !diferenciaisQuartos.some(
              (roomDifferential) => roomDifferential.codigoQuarto === room
            )
        )

        const roomsNotInHotel = this.hotelRoomsData.filter((room) =>
          roomsNotInDifferential.includes(room.codigo)
        )

        roomsNotInHotel.forEach((room) => {
          diferenciaisQuartos.push({
            codigoQuarto: room.codigo,
            nome: room.nome,
            valorAdicional: null,
            tipoValor: 2,
            tipoDiferencial: 1
          })
        })
      }
    },

    /**
     * Cria os objetos para as pensoes
     * caso não existam
     */
    createObjects() {
      if (!this.fluctuationData.diferenciaisQuartos?.length) {
        this.fluctuationData.diferenciaisQuartos = []
      }

      /* Filtra os quartos que já estão presentes em diferenciaisQuartos */
      const existingRooms = this.fluctuationData.diferenciaisQuartos.map(
        (item) => item.codigoQuarto
      )

      /* Adiciona novos quartos que não estão presentes em diferenciaisQuartos */
      const newRooms = this.hotelRoomsData.filter(
        (item) =>
          this.fluctuationData.quartos.includes(item.codigo) &&
          !existingRooms.includes(item.codigo)
      )

      newRooms.forEach((item) => {
        this.fluctuationData.diferenciaisQuartos.push({
          codigoQuarto: item.codigo,
          nome: item.nome,
          valorAdicional: null,
          tipoValor: 2,
          tipoDiferencial: 1
        })
      })

      /* Atualiza o nome para os itens existentes em diferenciaisQuartos */
      this.fluctuationData.diferenciaisQuartos.forEach((ItemDiferencial) => {
        const itemQuarto = this.hotelRoomsData.find(
          (itemQuarto) => itemQuarto.codigo === ItemDiferencial.codigoQuarto
        )

        if (itemQuarto) {
          ItemDiferencial.nome = itemQuarto.nome
        }
      })

      this.fluctuationData.diferenciaisQuartos.sort((a, b) => {
        return b.codigoQuarto - a.codigoQuarto
      })
    },

    removeAccomodationsHandler() {
      this.showInputs = false
      this.$emit('close')
      this.fluctuationData.diferenciaisQuartos = []
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--button {
    max-width: 265px;
    width: 265px;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }

  &--subtitle {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    line-height: 21px;
  }
}
</style>
